import UnderConstruction from '../components/UnderConstruction';

function Services(props){
    return(
        <UnderConstruction/>
    )
}

export default Services;